import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";




function NoneSelectedMessage(props){

    return (
    <div style={{padding:"0.25rem", paddingTop:"0.625rem", color: "#000", display: "flex", alignItems: "center", columnGap: "0.35rem"}}> 
    {props.icon === "loading" ? <FontAwesomeIcon pulse={props.icon==="loading"} icon={faSpinner}/>
        : <i className="icon icon-alert-info" style={{fontSize: "1rem"}}/>
    }
    <span>{props.message}</span>
    </div>)
}

export {NoneSelectedMessage}